import { Chip } from '@material-ui/core';

const COLOR_BY_TONE = {
  on: 'success',
  off: 'warning'
};

export function StatusPill({ tone, children }) {
  const color = COLOR_BY_TONE[tone] ?? 'default';
  return <Chip size="small" color={color} label={children} sx={{ fontWeight: 700 }} />;
}

export const fullName = (member) => `${member.membername}`.trim().replace(/\s+/g, ' ');
